function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from 'react';

var MetricsIcon = function MetricsIcon(_ref) {
  var props = _extends({}, _ref);

  return /*#__PURE__*/React.createElement("svg", {
    width: "18",
    height: "17",
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 8.24805L10.5 8.25391",
    stroke: "#626B77",
    strokeWidth: "1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 2.25195L7.5 2.24609",
    stroke: "#626B77",
    strokeWidth: "1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 14.252L7.5 14.2461",
    stroke: "#626B77",
    strokeWidth: "1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7499 8.24609L17.9999 8.25195",
    stroke: "#626B77",
    strokeWidth: "1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.25012 2.25391L0.000121987 2.24805",
    stroke: "#626B77",
    strokeWidth: "1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.25012 14.2539L0.000121987 14.248",
    stroke: "#626B77",
    strokeWidth: "1.5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "11.25",
    cy: "8.25",
    r: "1.5",
    stroke: "#626B77",
    strokeWidth: "1.5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "6.75",
    cy: "2.25",
    r: "1.5",
    transform: "rotate(-180 6.75 2.25)",
    stroke: "#626B77",
    strokeWidth: "1.5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "6.75",
    cy: "14.25",
    r: "1.5",
    transform: "rotate(-180 6.75 14.25)",
    stroke: "#626B77",
    strokeWidth: "1.5"
  }));
};

export default MetricsIcon;